module.exports = __webpack_public_path__ + "static/img/xxfw1.284dbd21.png";